import Iconify from "@/components/ui/Iconify";
import { useTranslations } from "@/lib/static-intl";
import { getMediaRecordPath } from "@/utils/media";
import PlaceMenuMedia from "../../../place-menu-media";
import Image from "next/image";

const PDW_HomeMenuSection = ({
  placeMenu,
  setCurrentTab,
  isCssForDialog,
  openPlaceMediaSlider,
}) => {
  const t = useTranslations("places.place_details_window");
  return (
    <div className="w-full flex flex-col gap-2">
      <div className="w-full flex items-center justify-between">
        <div className="w-fit flex items-center gap-2">
          <span className="font-semibold text-lg dark:text-white">
            {t("menu")}
          </span>
          <span className="font-bold text-lg text-black/30 dark:text-white/50">
            {placeMenu?.length}
          </span>
        </div>
        <button
          type="button"
          className="text-sm text-red font-medium"
          onClick={() => setCurrentTab("Menu")}
        >
          {t("view menu")}
        </button>
      </div>
      {placeMenu && placeMenu.length > 0 ? (
        <div
          className={`w-full grid grid-cols-2 ${
            isCssForDialog ? "lg:grid-cols-2" : "lg:grid-cols-4"
          } gap-4`}
        >
          {placeMenu?.filter?.((_p) => _p?.placeMenuMedia?.[0]?.filePath)
            ?.length >= 4 ? (
            placeMenu
              ?.filter?.((_p) => _p?.placeMenuMedia?.[0]?.filePath)
              ?.slice(0, 4)
              ?.map((_m, i) => (
                <div key={i} className="w-full flex flex-col gap-2">
                  <PlaceMenuMedia
                    menuId={_m?.id || _m?._id}
                    index={i}
                    menuFilePath={_m?.placeMenuMedia?.[0]?.filePath}
                    menuMedia={_m?.placeMenuMedia?.[0]}
                    openPlaceMediaSlider={openPlaceMediaSlider}
                    className={"!h-auto !w-auto aspect-square"}
                  />
                  <div className="w-full truncate text-lg tracking-tight">
                    {_m["itemName"]}
                  </div>
                  {_m["itemPrice"] && (
                    <div className="w-full truncate tracking-tight dark:text-white">
                      <span className="font-semibold dark:text-white">
                        {_m["itemPrice"]
                          ? isNaN(_m["itemPrice"])
                            ? _m["itemPrice"]
                            : new Intl.NumberFormat("en-US").format(
                                Number(_m["itemPrice"])
                              )
                          : ""}
                      </span>
                      {""} {t("won")}
                    </div>
                  )}
                </div>
              ))
          ) : (
            <div
              className={`${
                isCssForDialog ? "col-span-2" : "col-span-4"
              } flex flex-col gap-3`}
            >
              {placeMenu?.slice(0, 4)?.map((_m, i) => (
                <div key={i} className="w-full flex justify-between gap-2">
                  <div className="flex gap-1">
                    <span className="text-black/60 dark:text-white/70 tracking-tighter text-wrap">
                      {_m["itemName"]}
                    </span>
                    {_m?.placeMenuMedia?.[0]?.filePath && (
                      <button
                        type="button"
                        onClick={() =>
                          openPlaceMediaSlider(
                            [
                              getMediaRecordPath(_m?.placeMenuMedia?.[0], {
                                variant: "large",
                              }) || _m?.placeMenuMedia?.[0]?.filePath,
                            ],
                            i
                          )
                        }
                        className="w-fit h-fit"
                      >
                        <Iconify
                          icon={"majesticons:image-line"}
                          className={"!text-green-500 !min-w-5 !w-5 !h-5"}
                        />
                      </button>
                    )}
                  </div>
                  {_m["itemPrice"] && (
                    <div className="text-nowrap tracking-tight dark:text-white">
                      <span className="font-semibold dark:text-white">
                        {_m["itemPrice"]
                          ? isNaN(_m["itemPrice"])
                            ? _m["itemPrice"]
                            : new Intl.NumberFormat("en-US").format(
                                Number(_m["itemPrice"])
                              )
                          : ""}
                      </span>
                      {""} {t("won")}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className="flex flex-col gap-2 items-center justify-center h-[300px]">
          <Image
            src={"/no-data.png"}
            alt="no-data"
            width={50}
            height={50}
            className="object-contain"
          />
          <span className="text-xs text-black/30 dark:text-white/30">
            {t("no_menu")}
          </span>
        </div>
      )}
      <div className="w-full flex items-center">
        <div className="h-[1px] w-full bg-black/[0.08] dark:bg-white/[0.12]" />
        <button
          type="button"
          className="w-fit py-1.5 px-4 rounded-full bg-black/5 dark:bg-white/5 text-black/70 dark:text-white/70 text-sm flex items-center text-nowrap"
          onClick={() => setCurrentTab("Menu")}
        >
          {t("see more menu")}
          <Iconify
            icon={"lsicon:right-outline"}
            className={"!text-inherit !mt-0.5"}
          />
        </button>
        <div className="h-[1px] w-full bg-black/[0.08] dark:bg-white/[0.12]" />
      </div>
    </div>
  );
};

export default PDW_HomeMenuSection;
